import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createBlock as _createBlock, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/filter/box-open.svg'
import _imports_1 from '../../assets/filter/pencil-alt.png'
import _imports_2 from '../../assets/filter/trash-alt.png'
import _imports_3 from '../../assets/filter/box.svg'


const _withScopeId = n => (_pushScopeId("data-v-1796260c"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "d-flex flex-column",
  id: "containerGeral"
}
const _hoisted_2 = {
  class: "d-flex flex-column",
  id: "containerCard"
}
const _hoisted_3 = { class: "d-flex flex-row justify-content-between align-items-center pb-8" }
const _hoisted_4 = {
  class: "d-flex flex-row gap-4",
  id: "btnsInd"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  style: {"font-size":"22px"},
  class: "m-0 fas fa-arrow-left"
}, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  style: {"height":"fit-content","width":"fit-content","font-size":"18px"},
  class: "m-0 fas fa-plus"
}, null, -1))
const _hoisted_7 = /*#__PURE__*/_createStaticVNode("<div class=\"d-flex justify-content-around\" id=\"header\" data-v-1796260c><div class=\"col-3 d-flex justify-content-center align-items-center\" data-v-1796260c><span class=\"subtitulo titleList\" data-v-1796260c>MARCA </span></div><div class=\"col-3 d-flex justify-content-center align-items-center\" data-v-1796260c><span class=\"subtitulo titleList\" data-v-1796260c>PRODUTO</span></div><div class=\"col-3 d-flex justify-content-center align-items-center\" data-v-1796260c><span class=\"subtitulo titleList\" data-v-1796260c>TIPO </span></div><div class=\"col-3 d-flex justify-content-center align-items-center\" data-v-1796260c><span class=\"subtitulo titleList\" data-v-1796260c>AÇÕES </span></div></div>", 1)
const _hoisted_8 = {
  key: 0,
  class: "card d-flex justify-content-center",
  id: "empty"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "m-5",
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { id: "msgPesquisa" }, "Sua pesquisa não retornou nenhum dado. Verifique os campos e tente novamente.", -1))
const _hoisted_11 = [
  _hoisted_9,
  _hoisted_10
]
const _hoisted_12 = {
  key: 0,
  class: "skeleton-results bg-white mb-5",
  style: {"border-radius":"0 0 10px 10px","list-style":"none","padding":"0"}
}
const _hoisted_13 = { class: "col-3 d-flex justify-content-center align-items-center" }
const _hoisted_14 = { class: "col-3 d-flex justify-content-center align-items-center" }
const _hoisted_15 = { class: "col-3 d-flex justify-content-center align-items-center" }
const _hoisted_16 = { class: "col-3 d-flex justify-content-center align-items-center gap-2" }
const _hoisted_17 = {
  key: 1,
  id: "results",
  class: "bg-white",
  style: {"list-style":"none","padding":"0"}
}
const _hoisted_18 = { class: "col-3 d-flex justify-content-center align-items-center" }
const _hoisted_19 = { class: "texto text-center px-1" }
const _hoisted_20 = { class: "col-3 d-flex justify-content-center align-items-center" }
const _hoisted_21 = { class: "texto text-center" }
const _hoisted_22 = { class: "col-3 d-flex justify-content-center align-items-center" }
const _hoisted_23 = { class: "texto text-center" }
const _hoisted_24 = { class: "col-3 d-flex justify-content-center align-items-center" }
const _hoisted_25 = ["onClick"]
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: ""
}, null, -1))
const _hoisted_27 = [
  _hoisted_26
]
const _hoisted_28 = ["onClick"]
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: ""
}, null, -1))
const _hoisted_30 = [
  _hoisted_29
]
const _hoisted_31 = { id: "modais" }
const _hoisted_32 = {
  class: "modal fade",
  id: "excluirFiltro",
  tabindex: "-1",
  role: "dialog",
  "aria-labelledby": "excluirFiltro",
  "aria-hidden": "true"
}
const _hoisted_33 = {
  class: "modal-dialog modal-dialog-centered",
  role: "document"
}
const _hoisted_34 = { class: "modal-content" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal-header" }, [
  /*#__PURE__*/_createElementVNode("h5", { class: "modal-title" }, "Excluir Filtro"),
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "btn-close",
    "data-bs-dismiss": "modal",
    "aria-label": "Close"
  })
], -1))
const _hoisted_36 = {
  class: "modal-body",
  id: "modalBody"
}
const _hoisted_37 = { class: "card d-flex flex-row mt-4" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  alt: "",
  style: {"padding-right":"1.9rem"}
}, null, -1))
const _hoisted_39 = {
  class: "w-100 d-flex flex-column",
  id: "ulPaiListaCard"
}
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", { class: "titulosDoModal" }, "Produto", -1))
const _hoisted_41 = { class: "modal-footer" }
const _hoisted_42 = ["disabled"]
const _hoisted_43 = {
  key: 0,
  class: "spinner-border spinner-border-sm me-2",
  role: "status",
  "aria-hidden": "true"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Title = _resolveComponent("Title")!
  const _component_Button = _resolveComponent("Button")!
  const _component_ElSkeletonItem = _resolveComponent("ElSkeletonItem")!
  const _component_ElSkeleton = _resolveComponent("ElSkeleton")!
  const _component_Pagination = _resolveComponent("Pagination")!
  const _component_ModalAdicionarFiltro = _resolveComponent("ModalAdicionarFiltro")!
  const _component_ModalEditarFiltro = _resolveComponent("ModalEditarFiltro")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_Title, null, {
            default: _withCtx(() => [
              _createTextVNode("Gestão de Filtros")
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_Button, {
              type: "button",
              text: "Voltar",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.history.back()))
            }, {
              default: _withCtx(() => [
                _hoisted_5
              ]),
              _: 1
            }),
            _createVNode(_component_Button, {
              type: "button",
              text: "Adicionar Filtro",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.abrirModalAddFiltro())),
              style: {"white-space":"nowrap"}
            }, {
              default: _withCtx(() => [
                _hoisted_6
              ]),
              _: 1
            })
          ])
        ])
      ])
    ]),
    _createElementVNode("div", null, [
      _hoisted_7,
      (_ctx.buscaFiltro)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, _hoisted_11))
        : _createCommentVNode("", true),
      _createElementVNode("div", null, [
        (_ctx.skeleton)
          ? (_openBlock(), _createElementBlock("ul", _hoisted_12, [
              _createVNode(_component_ElSkeleton, {
                loading: true,
                animated: ""
              }, {
                template: _withCtx(() => [
                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList(10, (n) => {
                    return _createElementVNode("li", {
                      key: 'sk-' + n,
                      class: "d-flex align-items-center py-2 border-bottom"
                    }, [
                      _createElementVNode("div", _hoisted_13, [
                        _createVNode(_component_ElSkeletonItem, {
                          variant: "text",
                          style: {"width":"60%","height":"20px"}
                        })
                      ]),
                      _createElementVNode("div", _hoisted_14, [
                        _createVNode(_component_ElSkeletonItem, {
                          variant: "text",
                          style: {"width":"70%","height":"20px"}
                        })
                      ]),
                      _createElementVNode("div", _hoisted_15, [
                        _createVNode(_component_ElSkeletonItem, {
                          variant: "text",
                          style: {"width":"50%","height":"20px"}
                        })
                      ]),
                      _createElementVNode("div", _hoisted_16, [
                        _createVNode(_component_ElSkeletonItem, {
                          variant: "rect",
                          style: {"width":"32px","height":"32px","border-radius":"4px"}
                        }),
                        _createVNode(_component_ElSkeletonItem, {
                          variant: "rect",
                          style: {"width":"32px","height":"32px","border-radius":"4px"}
                        })
                      ])
                    ])
                  }), 64))
                ]),
                _: 1
              })
            ]))
          : (!_ctx.buscaFiltro && !_ctx.skeleton)
            ? (_openBlock(), _createElementBlock("ul", _hoisted_17, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filtros, (item, key) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: key,
                    class: "d-flex align-items-center py-2 border-bottom"
                  }, [
                    _createElementVNode("div", _hoisted_18, [
                      _createElementVNode("span", _hoisted_19, _toDisplayString(item.marca), 1)
                    ]),
                    _createElementVNode("div", _hoisted_20, [
                      _createElementVNode("span", _hoisted_21, _toDisplayString(item.filtro), 1)
                    ]),
                    _createElementVNode("div", _hoisted_22, [
                      _createElementVNode("span", _hoisted_23, _toDisplayString(item.tipo), 1)
                    ]),
                    _createElementVNode("div", _hoisted_24, [
                      _createElementVNode("button", {
                        class: "me-1",
                        onClick: ($event: any) => (_ctx.abrirModalEditFiltro(item))
                      }, _hoisted_27, 8, _hoisted_25),
                      _createElementVNode("button", {
                        class: "ms-1",
                        onClick: ($event: any) => (_ctx.openModal('excluirFiltro'), _ctx.clickFiltro(item))
                      }, _hoisted_30, 8, _hoisted_28)
                    ])
                  ]))
                }), 128))
              ]))
            : _createCommentVNode("", true)
      ]),
      (_openBlock(), _createBlock(_component_Pagination, {
        ref: "pagination",
        key: _ctx.route.path,
        arr: _ctx.filtros,
        totalBanco: _ctx.totalFiltros,
        onPageChanged: _ctx.handlePageChange,
        tipo: 'Filtros encontrados'
      }, null, 8, ["arr", "totalBanco", "onPageChanged"]))
    ]),
    _createElementVNode("div", _hoisted_31, [
      _createElementVNode("div", _hoisted_32, [
        _createElementVNode("div", _hoisted_33, [
          _createElementVNode("div", _hoisted_34, [
            _hoisted_35,
            _createElementVNode("div", _hoisted_36, [
              _createElementVNode("div", _hoisted_37, [
                _hoisted_38,
                _createElementVNode("div", _hoisted_39, [
                  _hoisted_40,
                  _createElementVNode("h6", null, "Deseja realmente excluir o " + _toDisplayString(_ctx.filtroClicked?.tipo) + " " + _toDisplayString(_ctx.filtroClicked?.marca) + " " + _toDisplayString(_ctx.filtroClicked?.filtro) + " ?", 1)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_41, [
              _createElementVNode("button", {
                type: "button",
                class: "btn",
                disabled: _ctx.loadExcluir,
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.deleteFiltro(_ctx.filtroClicked)))
              }, [
                (_ctx.loadExcluir)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_43))
                  : _createCommentVNode("", true),
                _createTextVNode(" Excluir ")
              ], 8, _hoisted_42)
            ])
          ])
        ])
      ])
    ]),
    _createVNode(_component_ModalAdicionarFiltro, {
      fechaModal: _ctx.fechaModalAddFiltro,
      marcas: _ctx.marcasDeFiltro,
      tiposDeFiltro: _ctx.tiposDeFiltro
    }, null, 8, ["fechaModal", "marcas", "tiposDeFiltro"]),
    _createVNode(_component_ModalEditarFiltro, {
      fechaModal: _ctx.fechaModalEditFiltro,
      marcas: _ctx.marcasDeFiltro,
      tiposDeFiltro: _ctx.tiposDeFiltro
    }, null, 8, ["fechaModal", "marcas", "tiposDeFiltro"])
  ], 64))
}